import { CheckMarkCircleIcon } from '../../../components'
import CancelIcon from '@mui/icons-material/Cancel'

export const consistencyIcons = {
  checkmark: {
    icon: <CheckMarkCircleIcon />,
  },
  exclamation: {
    icon: <CancelIcon fontSize="medium" />,
  },
  default: {
    icon: <CheckMarkCircleIcon />,
  },
}
